import { CadNextNotification } from '@mark43/cad-api';
import { Counter } from '@cad-arc';
import { eventNotificationPriorityToColors } from '../../../event-notifications/event-notifications';
import { highestNotificationPriorityForNotifications } from '../../../event-notifications/highest-notification-priority-for-notifications';
import { getCounterNotifications } from './get-counter-notifications';
import {
    HIGHT_PRIORITY_NOTIFICATION_ARIA_LABEL,
    STANDARD_PRIORITY_NOTIFICATION_ARIA_LABEL,
} from '../constants';

export function EventNotificationsCounter(props: {
    notifications: CadNextNotification[];
    style?: React.CSSProperties;
    showTotalCount?: boolean;
}) {
    if (props.notifications.length === 0) {
        return null;
    }

    const notificationsToInclude = props.showTotalCount
        ? props.notifications
        : getCounterNotifications(props.notifications);
    const highestNotificationPriority = highestNotificationPriorityForNotifications(
        notificationsToInclude
    );
    return (
        <Counter
            data-testid="EVENT_NOTIFICATIONS_COUNTER"
            maxCount={9}
            variant={highestNotificationPriority ? undefined : 'default'}
            aria-label={
                highestNotificationPriority === 'HIGH'
                    ? HIGHT_PRIORITY_NOTIFICATION_ARIA_LABEL
                    : STANDARD_PRIORITY_NOTIFICATION_ARIA_LABEL
            }
            style={{
                color: highestNotificationPriority
                    ? 'var(--arc-colors-negative-content)'
                    : undefined,
                backgroundColor: highestNotificationPriority
                    ? eventNotificationPriorityToColors[highestNotificationPriority].notchOrText
                    : undefined,
                ...(props.style ?? {}),
            }}
        >
            {notificationsToInclude.length}
        </Counter>
    );
}
